
















import Header from '@/components/lfs/Statistics/Toolbar.vue'
import { Component, Vue } from 'vue-property-decorator'
import { Meta } from '@sophosoft/vue-meta-decorator'
import { namespace } from 'vuex-class'

import HelpDlg from '@/components/lfs/Statistics/HelpDlg.vue'

const auth = namespace('auth')

@Component({
  components: {
    HelpDlg,
    Header
  }
})
export default class Statistics extends Vue {
  @Meta
  getMetaInfo() {
    return {
      title: `LeadFrog - ${ this.$t('statistic.title') }`
    }
  }

  isUpdated: boolean = false
  @auth.State('exhibitorId') protected _exhibitor: any
  protected getStatistics() {
    this.$store.dispatch('statistics/getStatistics', this._exhibitor)
  }

  protected updateStatistics() {
    this.getStatistics()
    this.$store.state.statistics.isUpdated = true
  }

  protected chartBlocks: any = {}

  protected mounted() {
    this.getStatistics()
  }
}
